import React from "react";
import orderBy from "lodash/orderBy";
import { selectCurrentJurisdictionId } from "store/app-state/application-navigation/applicationNavigation";
import {
  selectIndependentAuthoritiesForAuthenticatedUser,
  selectPublicAuthoritiesByJurisdiction,
} from "store/domain-data/authority/authority";
import { useStoreSelector } from "store/hooks";

export const useAuthoritySelectItems = () => {
  const jurisdictionId = useStoreSelector(selectCurrentJurisdictionId);
  const allPublicAuthoritiesInJurisdiction = useStoreSelector((state) =>
    selectPublicAuthoritiesByJurisdiction(state, jurisdictionId)
  );
  const independentAuthorities = useStoreSelector(selectIndependentAuthoritiesForAuthenticatedUser);

  // Merge public and independent authorities
  const authoritiesSelectItems = React.useMemo(() => {
    let authorities = allPublicAuthoritiesInJurisdiction;
    if (allPublicAuthoritiesInJurisdiction.length > 0 && independentAuthorities.length > 0) {
      authorities = authorities.concat(independentAuthorities);
    }

    return orderBy(authorities, ["displayName"]).map((authority) => ({
      value: authority.id,
      displayName: authority.displayName,
    }));
  }, [allPublicAuthoritiesInJurisdiction, independentAuthorities]);

  return authoritiesSelectItems;
};
